import SaveAltIcon from '@mui/icons-material/SaveAlt'
import { Box, styled, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid2'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { FC, PropsWithChildren } from 'react'
import { theme } from '../../theme'
import { FileIcon } from '../FileIcon'

const DocumentWrapper = styled(Stack, {
    shouldForwardProp: (propName: string) => propName !== 'isWrapper',
})<{ isWrapper: boolean }>(({ isWrapper, theme }) => ({
    alignItems: 'center',
    justifyContent: 'flex-start',
    background: isWrapper ? '#fff' : 'none',
    borderRadius: isWrapper ? '43px' : 0,
    padding: isWrapper ? '4px 12px' : '12px 0px',
    gap: '8px',
    '&:hover': {
        borderRadius: isWrapper ? '43px' : 0,
    },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
}))

type Props = PropsWithChildren<{
    name?: string
    url?: string
    isWrapper?: boolean
    isShared?: boolean
    size?: number
    type?: string
}>

export const DocumentIconName: FC<Props> = ({
    name = '',
    url,
    isWrapper = true,
    children,
    size,
    type,
    isShared = false,
}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <DocumentWrapper direction="row" isWrapper={isWrapper}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                    color: '#004B9F',
                }}>
                <FileIcon type={type} />
            </Box>
            <Grid
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                <Typography
                    variant="caption1"
                    sx={{
                        width: isShared ? (isMobile ? '40vw' : '30vw') : 'auto',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>
                    {decodeURI(name.split('/')?.pop() ?? '')}
                </Typography>
                {size && (
                    <Typography color="#5E626E" variant="caption2">
                        {size / 1000000 > 1
                            ? `${Math.round(size / 1000000)} МБ`
                            : `${Math.round(size / 1000)} КБ`}
                    </Typography>
                )}
            </Grid>
            {children}
            {url && (
                <Tooltip title="Скачать">
                    <IconButton
                        sx={{ color: '#5A5F72' }}
                        onClick={() => window.open(url, '_blank', 'noopener')}>
                        <SaveAltIcon />
                    </IconButton>
                </Tooltip>
            )}
        </DocumentWrapper>
    )
}
